var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.showHeader)?_c('TopHeader'):_vm._e(),_c('router-view'),_c('ToSModal',{directives:[{name:"show",rawName:"v-show",value:(_vm.modalVisible),expression:"modalVisible"}],attrs:{"loading":_vm.loading},on:{"confirm":_vm.onConfirm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }